import React, { Fragment, useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import {
    buscarAreasConfiguracion,
    buscarOrganizadoresConfiguracion
} from '../../../actions/configuracion';

import NuevoOrganizador from './NuevoOrganizador';
import EditarOrganizador from './EditarOrganizador';
import EliminarOrganizador from './EliminarOrganizador';

const Organizadores = () => {
    const { id } = useParams();
    const idArea = id;

    const dispatch = useDispatch();

    const { listado: listadoAreas } = useSelector(state => state.configuracion.areas);
    const { listado: listadoOrganizadores } = useSelector(state => state.configuracion.organizadores);

    const [organizadores, setOrganizadores] = useState([]);
    const [filterText, setFilterText] = useState('');

    const [organizadorAgregar, setOrganizadorAgregar] = useState(null);
    const [organizadorEditar, setOrganizadorEditar] = useState(null);
    const [organizadorEliminar, setOrganizadorEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    // Mapa id_area → nombre
    const mapaAreas = useMemo(() => {
        const map = {};
        (listadoAreas || []).forEach(a => {
            if (a._id) map[a._id] = a.nombre;
        });
        return map;
    }, [listadoAreas]);

    const nombreAreaActual = mapaAreas[idArea] || 'Área';

    // Breadcrumb
    useEffect(() => {
        const rutasBread = [
            {
                activo: false,
                nombre: 'Áreas',
                path: '/configuracion/areas'
            },
            {
                activo: true,
                nombre: `Organizadores - ${nombreAreaActual}`,
                path: `/configuracion/areas/organizadores/${idArea}`
            }
        ];
        dispatch(editarBreadcrumb(rutasBread));
    }, [dispatch, idArea, nombreAreaActual]);

    // Cargar catálogos necesarios
    useEffect(() => {
        // Áreas para el select
        dispatch(buscarAreasConfiguracion());
        // Organizadores del área actual
        dispatch(buscarOrganizadoresConfiguracion(idArea));
    }, [dispatch, idArea]);

    useEffect(() => {
        setOrganizadores(listadoOrganizadores || []);
    }, [listadoOrganizadores]);

    const handleAgregarOrganizador = (org) => {
        setOrganizadorEditar(null);
        setOrganizadorEliminar(null);
        setOrganizadorAgregar(org);
    };

    const handleEditarOrganizador = (org) => {
        setOrganizadorAgregar(null);
        setOrganizadorEliminar(null);
        setOrganizadorEditar(org);
    };

    const handleEliminarOrganizador = (org) => {
        setOrganizadorAgregar(null);
        setOrganizadorEditar(null);
        setOrganizadorEliminar(org);
    };

    const columns = [
        {
            name: 'Área',
            selector: row => mapaAreas[row.area] || 'Área no definida',
            wrap: true
        },
        {
            name: 'Nombre',
            selector: row => row.nombre,
            wrap: true
        },
        {
            name: 'Ubicaciones',
            selector: row => row.ubicaciones,
            center: true,
            width: '150px'
        },
        {
            name: '',
            cell: row => (
                <div className="text-right w-100">
                    <button
                        type="button"
                        className="btn btn-sm btn-link px-2 float-end"
                        onClick={() => handleEliminarOrganizador(row)}
                    >
                        <i className="fas fa-trash text-danger"></i>
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-link px-2 float-end"
                        onClick={() => handleEditarOrganizador(row)}
                    >
                        <i className="fas fa-edit text-warning"></i>
                    </button>
                    <Link
                        className="btn btn-sm btn-link px-2 float-end"
                        to={`/configuracion/areas/organizadores/ubicaciones/${row._id}`}
                    >
                        <i className="fas fa-list text-info"></i>
                    </Link>
                </div>
            )
        }
    ];

    const filteredItems = organizadores.filter(
        o =>
            (o.nombre || '').toLowerCase().includes(filterText.toLowerCase()) ||
            (mapaAreas[o.area] || '').toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponent = useMemo(() => (
        <div className="d-flex w-100 justify-content-between">
            <div className="col-md-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por área o nombre..."
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                />
            </div>

            <div className="d-flex justify-content-end">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleAgregarOrganizador({})}
                >
                    Agregar organizador
                </button>
            </div>
        </div>
    ), [filterText]);

    return (
        <Fragment>
            <NuevoOrganizador
                organizador={organizadorAgregar}
                reestablecerOrganizador={handleAgregarOrganizador}
                idAreaVista={idArea}
            />
            <EditarOrganizador
                organizador={organizadorEditar}
                reestablecerOrganizador={handleEditarOrganizador}
                idAreaVista={idArea}
            />
            <EliminarOrganizador
                organizador={organizadorEliminar}
                reestablecerOrganizador={handleEliminarOrganizador}
            />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-1 mt-5">Organizadores</h3>
                    <p className="mb-3">Área: <strong>{nombreAreaActual}</strong></p>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={filteredItems}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                            subHeader
                            subHeaderComponent={subHeaderComponent}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Organizadores;
